<div [appPropertyTooltip]="displayValue">
  Property ID: {{ displayValue }}
</div>
